import { EventTypeDataVersion } from '../types/ViewModel/EventTypeDataVersion';
import { EventTypeDataVersionBM } from '../types/BusinessModel/EventTypeDataVersionBM';

export class EventTypeDataVersionFactory {
    constructor() {}

    public newEventTypeDataVersion(inputEventTypeDataVersion: EventTypeDataVersionBM): EventTypeDataVersion {
        return new EventTypeDataVersion(
            inputEventTypeDataVersion.eventTypeDataVersionId,
            inputEventTypeDataVersion.version,
            inputEventTypeDataVersion.createdUtc,
            inputEventTypeDataVersion.comment
        );
    }
}
